<!--
* @Description:项目执行人数统计3
* @Date: 2024-01-18 18:14:01
-->
<template>
  <div
    class="survey"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="content" ref="ContentRef">
      <div class="content-warp">
        <div
          v-for="(item, index) in _data"
          :key="index"
          class="content-warp-item"
        >
          <div
            class="content-warp-item-number"
            style="margin-top: -25px"
            v-if="index + 1 == 3"
          >
            <p>{{ item.data.slice(0, 2) }}</p>
            <p>{{ item.data.slice(2, 4) }}</p>
          </div>
          <div v-else class="content-warp-item-number">
            {{ item.data }}
          </div>
          <component
            :is="item.comp"
            :numbers="index + 1"
            :controlColor="`var(--theme-color-${index + 1},#000)`"
          ></component>
          <div
            :style="index + 1 == 2 ? 'width: 265px' : ''"
            class="content-warp-item-tip"
          >
            {{ item.tipsText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { OptionData } from './type';
import { surveySvg31 } from './svg-components/index';
import { selfAdaption, dataProcessing } from './hooks';
import { onMounted, ref } from 'vue';
const porps = defineProps<{ optionData: OptionData }>();
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let comps = [surveySvg31, surveySvg31, surveySvg31];
let _data = dataProcessing(porps.optionData, comps);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.survey {
  width: 1024px;
  height: 485px;
  display: grid;
  .content {
    margin: auto;
    width: 1024px;
    height: 485px;
    padding: 112px 88px 111px 88px;
    .content-warp {
      height: 262px;
      width: 848px;
      display: flex;
      justify-content: space-between;
      .content-warp-item {
        width: 199px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        .content-warp-item-number {
          text-align: center;
          line-height: 38px;
          width: 87px;
          height: 50px;
          top: 67px;
          position: absolute;
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: 400;
          letter-spacing: 2px;
          color: #fff;
        }
        .content-warp-item-tip {
          width: 100%;
          height: 28px;
          position: absolute;
          bottom: 0px;
          text-align: center;
          @include title();
        }
      }
    }
  }
}
</style>
